import { render, staticRenderFns } from "./ScreenPlanificacionesAgenda.vue?vue&type=template&id=58a1c4e4&scoped=true"
import script from "./ScreenPlanificacionesAgenda.vue?vue&type=script&lang=js"
export * from "./ScreenPlanificacionesAgenda.vue?vue&type=script&lang=js"
import style0 from "./ScreenPlanificacionesAgenda.vue?vue&type=style&index=0&id=58a1c4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1c4e4",
  null
  
)

export default component.exports